import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import FilterSearchBar from 'components/shared/FilterSearchBar';
import FormInput from 'components/shared/BWFormControl/FormInput';
import FormSelect from 'components/shared/BWFormControl/FormSelect';
import { statusTypesOption } from 'utils/helpers';

const defaults = { search: '', is_active: 1 };

const WarrantyPeriodFilter = ({ onChange }) => {
  const methods = useForm({ defaultValues: defaults });
  const submit = () => onChange(methods.getValues());
  const clear = () => {
    methods.reset(defaults);
    onChange(defaults);
  };

  return (
    <FormProvider {...methods}>
      <FilterSearchBar
        title='Tìm kiếm'
        onSubmit={submit}
        onClear={clear}
        actions={[
          {
            title: 'Từ khóa',
            component: <FormInput field='search' placeholder='Nhập số tháng bảo hành' />,
          },
          {
            title: 'Trạng thái',
            component: <FormSelect field='is_active' list={statusTypesOption} />,
          },
        ]}
        colSize={4}
      />
    </FormProvider>
  );
};

export default WarrantyPeriodFilter;
